module.exports = __webpack_public_path__ + "static/media/Regolamento OP Bridgestone_Snowit_Def.a4c226e3.pdf";